import React from 'react';
import moment from 'moment';
import { Button } from 'antd';
import { Icon } from '@common/components';

export const DateRangeFilterButton = ({
  keyName,
  startDateArray,
  clearFilter,
}: {
  keyName: string;
  startDateArray: [string, string];
  clearFilter: (value: string) => void;
}) => (
  <Button onClick={() => clearFilter(keyName)}>
    <Icon icon="xMark" kind="light" />
    {`${moment(startDateArray[0]).format('L')} - ${moment(
      startDateArray[1]
    ).format('L')}`}
  </Button>
);
